<template>
  <div v-if="otherPartners" class="partners">
    <div class="lma-headline">Our Partners</div>
    <div ref="carousel" class="partners__list">
      <div
        v-for="item in otherPartners"
        :key="`partners-list-${item.id}`"
        class="partners__list-item"
      >
        <img
          :src="`/theme/rbFront/img/w/mediaArtSolution/otherPartners/${item.image}`"
          :alt="item.name"
          class="partners__image"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionPartners',
  props: {
    otherPartners: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      slickInitialized: false,
    }
  },
  watch: {
    otherPartners() {
      this.$nextTick(() => {
        this.destroySlick()
        this.initSlick()
      })
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.destroySlick()
  },
  methods: {
    /* eslint-disable no-undef */
    initSlick() {
      if (window.innerWidth <= 1080 && !this.slickInitialized) {
        $(this.$refs.carousel).slick({
          // Slick 옵션 설정
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1.66,
          centerMode: true,
          arrows: false,
        })
        this.slickInitialized = true
      }
    },
    /* eslint-disable no-undef */
    destroySlick() {
      if (this.slickInitialized) {
        $(this.$refs.carousel).slick('unslick') // eslint-disable-line no-undef
        this.slickInitialized = false
      }
    },
    handleResize() {
      if (window.innerWidth <= 1080) {
        this.initSlick()
      } else {
        this.destroySlick()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.partners {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 100px 0;
  &__list {
    display: flex;
    gap: 16px;
    justify-content: center;
  }
  @media screen and (max-width: 1080px) {
    padding: 80px 0;
    &__list {
      display: block;
    }
    &__image {
      width: 160px;
      margin: auto;
    }
  }
}
</style>
